import { render } from "./GroupADetails.vue?vue&type=template&id=26183713&scoped=true"
import script from "./GroupADetails.vue?vue&type=script&lang=js"
export * from "./GroupADetails.vue?vue&type=script&lang=js"

import "./GroupADetails.vue?vue&type=style&index=0&id=26183713&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26183713"]])

export default __exports__